import { useEffect, useRef, useState } from "react"
import gsap from "gsap"
import styled from "styled-components"
import useStore from "@state/store"
import CompareScreen from "./CompareScreen"
import SingleUnitScreen from "./SingleUnitScreen"

type Props = {
  isVisible: boolean
}

const FavortiesScreen = (props: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const { selectedRows, compareMode } = useStore((state) => ({
    selectedRows: state.selectedRows,
    compareMode: state.compareMode,
  }))

  useEffect(() => {
    if (ref.current) {
      if (props.isVisible) {
        gsap.to(ref.current, {
          autoAlpha: 1,
          duration: 0.6,
          ease: "power3.inOut",
        })
      } else {
        gsap.to(ref.current, {
          autoAlpha: 0,
          duration: 0.6,
          ease: "power3.inOut",
        })
      }
    }
  }, [props.isVisible])

  return (
    <Wrapper ref={ref} visible={props.isVisible}>
      {compareMode ? (
        <CompareScreen selectedRows={selectedRows} />
      ) : (
        <SingleUnitScreen selectedRows={selectedRows} />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div<{ visible: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  background-color: white;
  position: absolute;
  z-index: 150;
  opacity: ${(props) => (props.visible ? 1 : 0)};
`

export default FavortiesScreen
